import React from 'react';
import fields from '@/constants/fields';
import CompactTableRow from '@/components/table/CompactTableRow';
import QueryFiltersTableRows from '../../filters/components/QueryFiltersTableRows';

const QueryClauseAddRows = ({
  category,
  code,
  clause,
  queryUUID,
  saveErrors,
  firstClause,
}) => {
  const validationError = saveErrors.find((e) => (
    e.context.queryUUID === queryUUID && e.fields.includes(fields.CLAUSE)));

  return (
    <>
      <CompactTableRow
        numberOfColumns={6}
        className="aridhia-query-clause-add-header"
        rowId={firstClause ? 'cohort.clause.add' : 'cohort.clause.add.alternative'}
        active={!validationError}
        error={validationError}
      />
      <QueryFiltersTableRows
        category={category}
        code={code}
        clause={clause}
        queryUUID={queryUUID}
        canEdit
        isEditing
      />
    </>
  );
};

export default QueryClauseAddRows;
